<script setup lang="ts">
import { computed } from 'vue'
import { InformationCircleIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  requirements: {
    signed: boolean
    typeContrat: boolean
    modePaiement: boolean
    famille: boolean
    devisSigne?: boolean
    enfantsSignes?: boolean
    derogationReadyToSend?: boolean
    hasComment?: boolean
  }
}>()

const emit = defineEmits<{ (e: 'info-hover', value: boolean): void }>()

const allMet = computed(() =>
  props.requirements.signed &&
  props.requirements.typeContrat &&
  props.requirements.modePaiement &&
  props.requirements.famille &&
  (props.requirements.devisSigne ?? true) &&
  (props.requirements.enfantsSignes ?? true) &&
  (props.requirements.derogationReadyToSend ?? true) &&
  (props.requirements.hasComment ?? true),
)
const iconClass = computed(() => (allMet.value ? 'text-success' : 'text-error'))
</script>

<template>
  <div
    class="dropdown dropdown-top dropdown-end dropdown-hover"
    @mouseenter="emit('info-hover', true)"
    @mouseleave="emit('info-hover', false)"
  >
    <div tabindex="0" role="button" class="cursor-help">
      <InformationCircleIcon :class="['w-4 h-4 shrink-0', iconClass]" />
    </div>
    <div tabindex="0" class="dropdown-content z-[100] card card-compact bg-base-100 shadow-xl w-72 p-3 mb-1">
      <p class="font-semibold text-sm mb-2">Pour envoyer ADV, le devis doit avoir :</p>
      <ul class="list-disc list-inside text-sm space-y-1">
        <li :class="requirements.signed ? 'text-success' : 'text-error'">Signé {{ requirements.signed ? '✓' : '✗' }}</li>
        <li v-if="requirements.devisSigne !== undefined" :class="requirements.devisSigne ? 'text-success' : 'text-error'">Devis signé uploadé {{ requirements.devisSigne ? '✓' : '✗' }}</li>
        <li :class="requirements.typeContrat ? 'text-success' : 'text-error'">Type de contrat {{ requirements.typeContrat ? '✓' : '✗' }}</li>
        <li :class="requirements.modePaiement ? 'text-success' : 'text-error'">Moyen de paiement {{ requirements.modePaiement ? '✓' : '✗' }}</li>
        <li :class="requirements.famille ? 'text-success' : 'text-error'">Famille déclarée {{ requirements.famille ? '✓' : '✗' }}</li>
        <li v-if="requirements.enfantsSignes !== undefined" :class="requirements.enfantsSignes ? 'text-success' : 'text-error'">
          Devis liés (synchronisés) signés {{ requirements.enfantsSignes ? '✓' : '✗' }}
        </li>
        <li v-if="requirements.derogationReadyToSend !== undefined" :class="requirements.derogationReadyToSend ? 'text-success' : 'text-error'">
          Pas de dérogation bloquante {{ requirements.derogationReadyToSend ? '✓' : '✗' }}
        </li>
        <li v-if="requirements.hasComment !== undefined" :class="requirements.hasComment ? 'text-success' : 'text-error'">
          Un Commentaire est nécessaire {{ requirements.hasComment ? '✓' : '✗' }}
        </li>
      </ul>
    </div>
  </div>
</template>
